<template>
  <div>
    <CampaignsGrid campaign-type="all" />
  </div>
</template>

<script>
import CampaignsGrid from '../components/CampaignsGrid'
export default {
  components: {
    CampaignsGrid
  }
}
</script>

<style lang="scss" scoped>

</style>
